import React from 'react';

import { PrevButton, NextButton } from './Arrows';

function Counter({ counterHook, arrowsHook, carouselState }) {
  const { selectedSnap, snapCount } = counterHook;
  const { hasCounter, hasItemsToScroll, counterDivider } = carouselState;

  if (!hasCounter || !hasItemsToScroll) {
    return null;
  }

  return (
    <div className="mn_carouselCounter">
      <PrevButton arrowsHook={arrowsHook} />
      <div className="mn_carouselCounterNumber">
        <span>{selectedSnap + 1}</span> <span>{counterDivider}</span> <span>{snapCount}</span>
      </div>
      <NextButton arrowsHook={arrowsHook} />
    </div>
  );
}

export default Counter;
